import Table from "src/components/Shared/Table/Table";
import TableBody from "src/components/Shared/Table/TableBody";
import TableBodyLoader from "src/components/Shared/Table/TableBodyLoader";
import TRHeader from "src/components/Shared/Table/TRHeader";

const ActivityTable = ({ ...props }) => {
  return (
    <Table>
      <TRHeader>
        <th scope="col" className="bg-gray-50 py-3.5 pl-3 pr-3 text-left text-sm font-semibold text-gray-900 leading-none first:rounded-tl-lg">
          Name
        </th>
        <th scope="col" className="bg-gray-50 hidden lg:table-cell py-3.5 pl-3 pr-3 text-left text-sm font-semibold text-gray-900 leading-none first:rounded-tl-lg">
          Activity Type
        </th>
        <th scope="col" className="bg-gray-50 py-3.5 pl-3 pr-3 text-left text-sm font-semibold text-gray-900 leading-none first:rounded-tl-lg">
          Dashboard <span className="md:inline hidden">Accessed</span>
        </th>
        <th scope="col" className="bg-gray-50 py-3.5 pl-3 pr-3 text-left text-sm font-semibold text-gray-900 leading-none first:rounded-tl-lg">
          Date
        </th>
        <th scope="col" className="bg-gray-50 relative py-3.5 pl-3 pr-3 leading-none last:rounded-tr-lg">
          <span className="sr-only">Edit</span>
        </th>
      </TRHeader>
      <TableBody>
        <TableBodyLoader props={props} colSpan="5">
          {props.children}
        </TableBodyLoader>
      </TableBody>
    </Table>
  );
};

export default ActivityTable;
